import { Injectable } from '@angular/core';
import { RegistrationFirstStepModel, RegistrationCompleteModel } from '../models/registration/registration.models';
import { GlobalHttpClient } from '../global.http.client';
import { TenderTeamMemberRegistrationModel } from '../models/registration/registration.models';
import { Address } from '../models/common/address';

@Injectable()
export class RegistrationService {
    constructor(private http: GlobalHttpClient) {
    }

    addressLookup(address: string) {
        var response = this.http.get(`addresslookup/${address}`);

        return response;
    }

    addressRetrieval(id: string) {
        var response = this.http.get(`addresslookup/retrieve/${id}`);

        return response;
    }

    checkValidEmail(email: string) {
        var response = this.http.get(`addresslookup/emailvalidate/${email}`);

        return response;
    }

    getRegistrationPageText(model: RegistrationFirstStepModel) {
        var response = this.http.post(`registration/getRegistrationPageText`, model);

        return response;
    }

    getRegistrationPageFooterText(model: RegistrationFirstStepModel) {
        var response = this.http.post(`registration/getRegistrationPageFooterText`, model);

        return response;
    }

    firstStepComplete(model: RegistrationFirstStepModel) {
        var response = this.http.post(`registration/firstStepComplete`, model);

        return response;
    }

    registrationComplete(model: RegistrationCompleteModel) {
        var response = this.http.post(`registration/registrationComplete`, model);

        return response;
    }

    validateEmail(token: string) {
        var response = this.http.post(`registration/validateEmail`, { token: token });

        return response;
    }

    isRegistrationTokenValid(token: string) {
        var response = this.http.getWithParams('registration/registrationTokenValid', { token: token });

        return response;
    }

    getDetailsFromToken(token: string) {
        return this.http.post(
            `tenderTeamMembers/getDetailsFromToken`, { token: token });
    }

    confirmTeamMemberDetails(model: TenderTeamMemberRegistrationModel) {
        return this.http.post(`registration/verifyTeamMember`, model);
    }

    unsubscribe(id: number) {
        return this.http.get(`registration/unsubscribe/${id}`);
    }

    linkAccount(username: string, password: string) {
        return this.http.post('linkAccount', { username: username, password: password });
    }

    savePreferences(locationIds: number[], categoryIds: number[], userId: number) {
        return this.http.post('linkAccount/savepreferences',
            { locationIds: locationIds, categoryIds: categoryIds, userId: userId });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/registration.service.ts